<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-cash-coin"></i>
              Depositar o cobrar cheque
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <form id="deposit-form" @submit.prevent="depositForm">
            <div class="modal-body form-card form-card--bare mt-4">
              <div class="form-card__field">
                <label class="form-card__label" for="deposit-fund">Caja de destino</label>
                <select
                  id="deposit-fund"
                  v-model="fund"
                  name="fund_id"
                  class="custom-select"
                >
                  <option :value="null" disabled>Elija una caja de destino</option>
                  <option v-for="f in availableFunds" :key="f.id" :value="f.id">{{ f.name }}</option>
                </select>
                <div v-if="availableFunds.length" class="form-card__hint">
                  Se muestran todas las cajas disponibles
                </div>
                <div v-else class="form-card__error">
                  No hay cajas disponibles
                </div>
              </div>
            </div>

            <div class="form-card__footer">
              <button type="button" class="form-card__btn" @click="close">Cancelar</button>
              <button
                type="submit"
                class="form-card__btn form-card__btn--primary"
                :disabled="!fund"
              >
                <i class="bi bi-check-lg"></i>
                Depositar o cobrar cheque
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['funds'],
  data() {
    return {
      fund: null,
    };
  },
  computed: {
    availableFunds() {
      return this.funds || [];
    },
  },
  methods: {
    depositForm() {
      if (!this.fund) return;
      this.$emit('fundSelected', this.fund);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-content {
  background-color: var(--surface);
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}
</style>
